import { render, staticRenderFns } from "./NoFoundItem.vue?vue&type=template&id=2ae1f6c4"
import script from "./NoFoundItem.vue?vue&type=script&lang=js"
export * from "./NoFoundItem.vue?vue&type=script&lang=js"
import style0 from "./NoFoundItem.vue?vue&type=style&index=0&id=2ae1f6c4&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports